// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-form-wrapper {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
.login-form {
    width: 400px;
    box-shadow: 0 0 10px darkgray;
    background: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;
}
.login-form input {
    cursor: text;
    width: 250px;
    height: 40px;
    padding: 0 10px;
    border: 1px solid var(--psblue);
}
.login-form input:focus {
    outline: none;
    outline: 1px solid var(--psblue)
}
.login-form>* {
    margin-bottom: 10px;
}
.login-form button {
    width: 200px;
    height: 40px;
    cursor: pointer;
    background: var(--psblue);
    color: white;
    border: none;
    margin: 0 0 10px 0;
    width: 250px;
}
.login-form button:hover {
    background: var(--psblue-accent)
}

.login-form button:active {
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}
`, "",{"version":3,"sources":["webpack://./src/login/login.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,+BAA+B;AACnC;AACA;IACI,aAAa;IACb;AACJ;AACA;IACI,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI;AACJ;;AAEA;IACI,sCAAsC;AAC1C","sourcesContent":[".login-form-wrapper {\n    width: 100vw;\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.login-form {\n    width: 400px;\n    box-shadow: 0 0 10px darkgray;\n    background: white;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 30px;\n}\n.login-form input {\n    cursor: text;\n    width: 250px;\n    height: 40px;\n    padding: 0 10px;\n    border: 1px solid var(--psblue);\n}\n.login-form input:focus {\n    outline: none;\n    outline: 1px solid var(--psblue)\n}\n.login-form>* {\n    margin-bottom: 10px;\n}\n.login-form button {\n    width: 200px;\n    height: 40px;\n    cursor: pointer;\n    background: var(--psblue);\n    color: white;\n    border: none;\n    margin: 0 0 10px 0;\n    width: 250px;\n}\n.login-form button:hover {\n    background: var(--psblue-accent)\n}\n\n.login-form button:active {\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
